import type { PropOptions, VueConstructor } from 'vue';
import Vue from 'vue';
import type { Testimonial, TestimonialAuthor } from '~/types/graphql';
import { computed } from '~/components/partials/public-portfolio/PublicPortfolioTestimonials/mixins/publicPortfolioTestimonialMixin';

export const publicPortfolioTestimonialPropMixin = Vue.extend({
  name: 'PublicPortfolioTestimonialPropMixin',
  props: {
    testimonials: {
      type: Array,
      required: true,
    } as PropOptions<Array<Testimonial>>,
  },
  computed,
  methods: {
    getAuthorName(author: TestimonialAuthor): string {
      if (author.firstname && author.lastname) {
        return `${author?.firstname} ${author?.lastname}`;
      } else {
        return author?.firstname || author?.lastname || '';
      }
    },
  },
});
export default publicPortfolioTestimonialPropMixin;

export type PublicPortfolioTestimonialPropMixinType = VueConstructor<
  Vue & InstanceType<typeof publicPortfolioTestimonialPropMixin>
>;
